<div class="tracking-scroller">
    <div class="tracking-container" [style.min-width]="containerWidth">
        @if (!!shipment.tracking) {
            <app-tracking-group
                    [group]="shipment.tracking"
                    [shipment]="shipment"
            >
            </app-tracking-group>
        } @else {
            <span i18n>No tracking information is available for this shipment</span>
        }
    </div>
</div>
